/** Force les listes Autocomplete à s'ouvrir sous le champ (évite de masquer la recherche dans les dialogs). */
export const autocompletePopperSlotProps = {
    popper: {
        placement: "bottom-start",
        modifiers: [
            { name: "flip", enabled: false },
            { name: "preventOverflow", enabled: true, options: { altAxis: true, tether: true } },
        ],
    },
    paper: {
        sx: { maxHeight: 280 },
    },
};
